import { render, staticRenderFns } from "./mainparametrs.vue?vue&type=template&id=58044193&scoped=true"
import script from "./mainparametrs.vue?vue&type=script&lang=js"
export * from "./mainparametrs.vue?vue&type=script&lang=js"
import style0 from "./mainparametrs.vue?vue&type=style&index=0&id=58044193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58044193",
  null
  
)

export default component.exports